'use client';

import Script from 'next/script';
import { env } from '../lib';

declare global {
  interface Window {
    okeWidgetApi?: {
      initWidget: (element: HTMLElement | null) => void;
    };
    _okendoInitialized?: boolean;
  }
}

export function OkendoScript() {
  if (!env.NEXT_PUBLIC_OKENDO_SUBSCRIBER_ID) {
    return null;
  }

  return (
    <>
      <meta
        name="oke:subscriber_id"
        content={env.NEXT_PUBLIC_OKENDO_SUBSCRIBER_ID}
      />
      <Script
        id="okendo-reviews-script"
        src="https://cdn-static.okendo.io/reviews-widget-plus/js/okendo-reviews.js"
        onLoad={() => {
          if (!window._okendoInitialized) {
            window._okendoInitialized = true;

            // Dispatch the custom event that components are listening for
            document.dispatchEvent(
              new CustomEvent('oke-script-loaded', {
                bubbles: false,
                cancelable: false,
              })
            );
          }
        }}
        onError={() => {
          // biome-ignore lint/suspicious/noConsole: <explanation>
          console.error('Failed to load Okendo reviews script');
        }}
      />
    </>
  );
}
